import React, {
	Component
} from 'react';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupButton
} from 'reactstrap';
import PropTypes from 'prop-types';
import {
	connect
} from 'react-redux';
import {
	bindActionCreators
} from 'redux';
import {
	withRouter
} from 'react-router-dom';
import {
	compose
} from 'recompose';
import IdleTimer from 'react-idle-timer';
import StripeCheckout from 'react-stripe-checkout';
import Moment from 'react-moment';

import Checkout from '../../components/Checkout';

import * as subscriptionsActions from '../../actions/subscriptionsActions';

// Subscriptions
import withSubscriptions from '../../components/withSubscriptions';

class Subscriptions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			subscription: null,
			hasSubscriptionsChanges: false,
			collapse: true,
			subscriptions: this.props.subscriptions

		};

		this.createSubscriptions = this.createSubscriptions.bind(this);
		this.updateCardDetails = this.updateCardDetails.bind(this);
		this.cancelSubscriptions = this.cancelSubscriptions.bind(this);
		this.reactivateSubscriptions = this.reactivateSubscriptions.bind(this);
		this.updateSubscriptionProductsState = this.updateSubscriptionProductsState.bind(this);
		this.saveSubscriptions = this.saveSubscriptions.bind(this);
		this.saveSubscriptionsEvent = this.saveSubscriptionsEvent.bind(this);
		this.toggle = this.toggle.bind(this);
	}

	componentWillMount() {
		if (!this.state.subscriptions || !this.state.subscriptions.id || this.state.subscriptions.id === '') {
			this.setState({
				subscriptions: this.context.subscriptions
			});
		}
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			subscriptions: nextProps.subscriptions
		});
	}

	createSubscriptions(token, description) {
		event.preventDefault();
		
		// Find products to add. If a product is in state and not in context, then it needs to be added.
		var toAdd = [];
		for (var i = 0; i < this.state.subscriptions.products.length; i++) {
			var nextProduct = this.state.subscriptions.products[i];
			toAdd.push(nextProduct.product);
		}
		
		this.props.actions.createSubscriptions('deviceId', this.context.authToken, token.email, token.id, null, toAdd).then((responseSubscriptions) => {
			if (responseSubscriptions.errorType) {
				if (responseSubscriptions.errorMessage) {
					alert('Could not create subscriptions. ' + responseSubscriptions.errorMessage);
				} else {
					alert('Could not create subscriptions.');
				}
			}
		});
		
		this.setState({
			hasSubscriptionsChanges: false
		});
	}

	updateCardDetails(token, description) {
		event.preventDefault();
		this.props.actions.updateCardDetails('deviceId', this.context.authToken, token.email, token.id);
	}

	saveSubscriptions() {
		if (this.state.hasSubscriptionsChanges) {
			// Find products to remove. If a product is not in state and in context, then it needs to be removed.
			var toRemove = [];
			for (var i = 0; i < this.context.subscriptions.products.length; i++) {
				var prevProduct = this.context.subscriptions.products[i];
				var found = this.state.subscriptions.products.filter(product => product.product === prevProduct.product);
				if (found.length == 0) {
					toRemove.push(prevProduct.product);
				}
			}
			
			// Find products to add. If a product is in state and not in context, then it needs to be added.
			var toAdd = [];
			for (var i = 0; i < this.state.subscriptions.products.length; i++) {
				var nextProduct = this.state.subscriptions.products[i];
				var found = this.context.subscriptions.products.filter(product => product.product === nextProduct.product);
				if (found.length == 0) {
					toAdd.push(nextProduct.product);
				}
			}
			
			// Special case: Removing all products. Cancel subscription instead.
			if (toRemove.length > 0 && toRemove.length == this.context.subscriptions.products.length && toAdd.length == 0) {
				cancelSubscriptions();
				return;
			}
			
			// Remove products
			if (toRemove.length > 0) {
				this.props.actions.removeProducts('deviceId', this.context.authToken, toRemove);
			}
			
			// Add products
			if (toAdd.length > 0) {
				this.props.actions.addProducts('deviceId', this.context.authToken, toAdd);
			}
			
			this.setState({
				hasSubscriptionsChanges: false
			});
		}

		var button = document.getElementById('saveSubscriptions');
		button.disabled = true;
		button.classList.add('disabled');
		button.onclick = undefined;
	}

	saveSubscriptionsEvent(event) {
		if (event) {
			event.preventDefault();
		}

		if (this.refs.saveSubscriptionsTimer) {
			this.refs.saveSubscriptionsTimer.pause();
		}
		
		if (this.state.hasSubscriptionsChanges) {
			// Find products to remove. If a product is not in state and in context, then it needs to be removed.
			var toRemove = [];
			for (var i = 0; i < this.context.subscriptions.products.length; i++) {
				var prevProduct = this.context.subscriptions.products[i];
				var found = this.state.subscriptions.products.filter(product => product.product === prevProduct.product);
				if (found.length == 0) {
					toRemove.push(prevProduct.product);
				}
			}
			
			// Find products to add. If a product is in state and not in context, then it needs to be added.
			var toAdd = [];
			for (var i = 0; i < this.state.subscriptions.products.length; i++) {
				var nextProduct = this.state.subscriptions.products[i];
				var found = this.context.subscriptions.products.filter(product => product.product === nextProduct.product);
				if (found.length == 0) {
					toAdd.push(nextProduct.product);
				}
			}
			
			// Special case: Removing all products. Cancel subscription instead.
			if (toRemove.length > 0 && toRemove.length == this.context.subscriptions.products.length && toAdd.length == 0) {
				this.cancelSubscriptions();
				return;
			}
			
			// User not removing all products.
			if (window.confirm("Save changes to subscription?")) {
				this.saveSubscriptions();
			}
		}
	}

	cancelSubscriptions(event) {
		if (event) {
			event.preventDefault();
		}

		if (window.confirm("Cancel subscription? Your subscription will continue to the end of the current period. You will be able to reactivate your subscriptions if you change your mind later.")) {
			this.props.actions.cancelSubscriptions('deviceId', this.context.authToken);
			
			this.setState({
				hasSubscriptionsChanges: false
			});
		}
	}

	reactivateSubscriptions(event) {
		this.props.actions.reactivateSubscriptions('deviceId', this.context.authToken);
		
		this.setState({
			hasSubscriptionsChanges: false
		});
	}

	updateSubscriptionProductsState(event) {
		var createSubscriptionsButton = document.getElementById('createSubscriptions');
		if (createSubscriptionsButton) {
			createSubscriptionsButton.removeAttribute('disabled');
			createSubscriptionsButton.classList.remove('disabled');
			createSubscriptionsButton.onclick = this.createSubscriptionsEvent;
		}
		
		if (this.refs.saveSubscriptionsTimer) {
			this.refs.saveSubscriptionsTimer.reset();
		}
		var saveSubscriptionsButton = document.getElementById('saveSubscriptions');
		if (saveSubscriptionsButton) {
			saveSubscriptionsButton.removeAttribute('disabled');
			saveSubscriptionsButton.classList.remove('disabled');
			saveSubscriptionsButton.onclick = this.saveSubscriptionsEvent;
		}

		const field = event.target.name;
		const subscriptions = this.state.subscriptions;

		var found;
		if (subscriptions != undefined && subscriptions.products != undefined) {
			found = subscriptions.products.filter(product => product.product === field);
		} else {
			found = [];
		}

		if (event.target.checked) {
			if (found.length == 0) {
				var newProducts;
				if (subscriptions != undefined && subscriptions.products != undefined) {
					newProducts = subscriptions.products.slice();
				} else {
					newProducts = [];
				}
				newProducts.push({product: field});
				
				return this.setState({
					subscriptions: { ...subscriptions, products: newProducts },
					hasSubscriptionsChanges: true
				});
			}
		} else if (found.length > 0) {
			var newProducts;
			if (subscriptions != undefined && subscriptions.products != undefined) {
				newProducts = [ ...subscriptions.products.filter(product => product.product !== field) ];
			} else {
				newProducts = [];
			}
			
			return this.setState({
				subscriptions: { ...subscriptions, products: newProducts },
				hasSubscriptionsChanges: true
			});
		}
		
		// TODO: Update price in Stripe
	}

	toggle() {
		this.setState({
			collapse: !this.state.collapse
		});
	}
	
  render() {
  	  const stripeKey = "pk_live_N6skJJ1RKvKGGqj5oVJW2KSO";
  	  //const stripeKey = "pk_test_CitJD8CuJUuY8q67rFDIhaiP";
	
	  const subscriptions = this.state.subscriptions;
	  
	  var haveProduct = {};
	  if (subscriptions != undefined && subscriptions.products != undefined) {
	  	  for (var i = 0; i < subscriptions.products.length; i++) {
			  var product = subscriptions.products[i];
	  		  haveProduct[product.product] = true;
	  	  }
	  }
	  
	  if (subscriptions.subscriptionBegin && subscriptions.subscriptionBegin !== '' && subscriptions.subscriptionEnd && subscriptions.subscriptionEnd !== '') {
		  if (subscriptions.status == 'active') {
	  	  	return (
				<IdleTimer ref="saveSubscriptionsTimer" timeout={5000} startOnLoad={false} idleAction={this.saveSubscriptionsEvent}>
	  			<Card>
	  			  <CardHeader>
	  			    <strong>Monthly Subscription</strong>
	  			  </CardHeader>
	  			  <CardBody>
					  <p>You have a monthly subscription that will renew automatically on <Moment format="LL" date={subscriptions.subscriptionEnd} />.</p>
					  
					<Form>
					<FormGroup check>
					  <Label check>
					    <Input 
							id="departureScheduling" 
							name="DepartureScheduling"
							type="checkbox" 
							onChange={this.updateSubscriptionProductsState}
							checked={haveProduct['DepartureScheduling'] != undefined ? haveProduct['DepartureScheduling'] : false} /> <strong>Departure Scheduling</strong> ($1.99 per month)<br/>
							Set departures over the next 24 hours or on a recurring weekly schedule.
					  </Label>
					</FormGroup>
					<br/>
							
					</Form>
							
					  <p><small>Monthly subscription automatically renews unless subscription is canceled at least 24-hours
				before the end of the current period. Account will be charged for renewal within
				24-hours prior to the end of the current period, and identify the cost of the renewal.</small></p>
	  			  </CardBody>
	  			  <CardFooter>
		            <Button 
						id="saveSubscriptions" 
						type="submit" 
						size="sm" 
						color="primary" 
						onClick={this.saveSubscriptionsEvent}
						disabled={true}><i className="fa fa-dot-circle-o"></i> Save Subscription</Button>
	  				  <StripeCheckout
	  				    name="Update Card Details"
	  					image="/img/logo-symbol.png"
	  					label={'Update Card Details'}
	  					panelLabel={'Update Card Details'}
	  					email={this.context.authUser.email}
	  				    token={this.updateCardDetails}
	  					zipCode={true}
	  				    stripeKey={stripeKey}>
		  	            <Button 
		  					type="submit" 
		  					size="sm" 
		  					color="secondary"><i className="fa"></i> Update Card Details</Button>
					  </StripeCheckout>
	  	            <Button 
	  					type="submit" 
	  					size="sm" 
	  					color="danger" 
	  					onClick={this.cancelSubscriptions}><i className="fa fa-ban"></i> Cancel Subscription</Button>
					<span> <small>Last updated <Moment fromNow>{this.state.subscriptions.lastUpdated}</Moment></small></span>
	  			  </CardFooter>
	  			</Card>
				</IdleTimer>
	  	  	);
		  } else if (subscriptions.status == 'canceled' && new Date(subscriptions.subscriptionEnd).getTime() > new Date().getTime()) {
	  	  	return (
	  			<Card>
	  			  <CardHeader>
	  			    <strong>Monthly Subscription</strong>
	  			  </CardHeader>
	  			  <CardBody>
	  				  <p>Your monthly subscription has been canceled and will end on <Moment format="LL" date={subscriptions.subscriptionEnd} />.</p>
				  	  <ul>
						<DepartureSchedulingCanceled show={haveProduct['DepartureScheduling'] != undefined && haveProduct['DepartureScheduling']}/>
					  </ul>
				  </CardBody>
	  			  <CardFooter>
	  	            <Button 
	  					type="submit" 
	  					size="sm" 
	  					color="primary" 
	  					onClick={this.reactivateSubscriptions}><i className="fa fa-dot-circle-o"></i> Reactivate Subscription</Button>
  				  <StripeCheckout
  				    name="Update Card Details"
  					image="/img/logo-symbol.png"
  					label={'Update Card Details'}
  					panelLabel={'Update Card Details'}
  					email={this.context.authUser.email}
  				    token={this.updateCardDetails}
  					zipCode={true}
  				    stripeKey={stripeKey}>
	  	            <Button 
	  					type="submit" 
	  					size="sm" 
	  					color="secondary"><i className="fa fa-dot-circle-o"></i> Update Card Details</Button>
					  </StripeCheckout>
					<span> <small>Last updated <Moment fromNow>{this.state.subscriptions.lastUpdated}</Moment></small></span>
	  			  </CardFooter>
	  			</Card>
	  	  	);
		  }
	  }
	  
    return (
		<Card>
		  <CardHeader>
		    <strong>Monthly Subscription</strong>
		  </CardHeader>
		  <CardBody>
			<p>Thank you for trying SenseEV. Please activate your trial subscription.</p>
		    <p>Select products:</p>

			<Form>
			<FormGroup check>
			  <Label check>
			    <Input 
					id="departureScheduling" 
					name="DepartureScheduling"
					type="checkbox" 
					onChange={this.updateSubscriptionProductsState}
					checked={haveProduct['DepartureScheduling'] != undefined ? haveProduct['DepartureScheduling'] : false}  /> <strong>Departure Scheduling</strong> ($1.99 per month after 30-day trial)<br/>
					Set departures over the next 24 hours or on a recurring weekly schedule.
			  </Label>
			</FormGroup>
			<br/>
		
			</Form>

			<p><small>Payment will be charged at confirmation of purchase.
		Monthly subscription automatically renews unless subscription is canceled at least 24-hours
		before the end of the current period. Account will be charged for renewal within
		24-hours prior to the end of the current period, and identify the cost of the renewal.</small></p>
		  </CardBody>
		  <CardFooter>
			  <StripeCheckout
			    name="Subscription"
			    description="Monthly"
				image="/img/logo-symbol.png"
				label={'Subscribe'}
				panelLabel={'Subscribe'}
				email={this.context.authUser.email}
			    token={this.createSubscriptions}
			    currency="USD"
				zipCode={true}
			    stripeKey={stripeKey}>
  	            <Button 
					id="createSubscriptions"
  					type="submit" 
  					size="sm" 
  					color="primary"
					disabled={true}><i className="fa fa-dot-circle-o"></i> Subscribe</Button>
			  </StripeCheckout>
		  </CardFooter>
		</Card>
    )
  }
}

function DepartureSchedulingCanceled(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<li><strong>Departure Scheduling</strong></li>
  	);
}

function mapStateToProps(state, ownProps) {
	let subscriptions = {
		id: '', subscriptionBegin: '', subscriptionEnd: '', products: []
	};
	
	if (state.subscriptions && state.subscriptions.id) {
		return {
			subscriptions: state.subscriptions,
		}
	}
	
	return {
		subscriptions: subscriptions,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(subscriptionsActions, dispatch)
	}
}

Subscriptions.contextTypes = {
	subscriptions: PropTypes.object.isRequired,
	authUser: PropTypes.object.isRequired,
	authToken: PropTypes.string.isRequired
}

Subscriptions.propTypes = {
	actions: PropTypes.object.isRequired,
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withSubscriptions
)(Subscriptions);



// WEBPACK FOOTER //
// ./src/views/Subscriptions/Subscriptions.js